export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'
export const SEND_VERIFICATION_CODE_REQUEST = 'SEND_VERIFICATION_CODE_REQUEST'
export const SEND_VERIFICATION_CODE_SUCCESS = 'SEND_VERIFICATION_CODE_SUCCESS'
export const SEND_VERIFICATION_CODE_FAILURE = 'SEND_VERIFICATION_CODE_FAILURE'
export const VERIFY_PHONE_NUMBER_REQUEST = 'VERIFY_PHONE_NUMBER_REQUEST'
export const VERIFY_PHONE_NUMBER_SUCCESS = 'VERIFY_PHONE_NUMBER_SUCCESS'
export const VERIFY_PHONE_NUMBER_FAILURE = 'VERIFY_PHONE_NUMBER_FAILURE'
export const GET_MEMBER_INFO_REQUEST = 'GET_MEMBER_INFO_REQUEST'
export const GET_MEMBER_INFO_SUCCESS = 'GET_MEMBER_INFO_SUCCESS'
export const GET_MEMBER_INFO_FAILURE = 'GET_MEMBER_INFO_FAILURE'
export const UPDATE_MEMBER_INFO_REQUEST = 'UPDATE_MEMBER_INFO_REQUEST'
export const UPDATE_MEMBER_INFO_SUCCESS = 'UPDATE_MEMBER_INFO_SUCCESS'
export const UPDATE_MEMBER_INFO_FAILURE = 'UPDATE_MEMBER_INFO_FAILURE'
export const UPDATE_CREDIT_CARD_REQUEST = 'UPDATE_CREDIT_CARD_REQUEST'
export const UPDATE_CREDIT_CARD_SUCCESS = 'UPDATE_CREDIT_CARD_SUCCESS'
export const UPDATE_CREDIT_CARD_FAILURE = 'UPDATE_CREDIT_CARD_FAILURE'
export const CLEAN_STATUS = 'CLEAN_STATUS'

export const loginReq = () => ({
    type: LOGIN_REQUEST,
})

export const loginSuccess = payload => ({
    type: LOGIN_SUCCESS,
    payload
})

export const loginFailure = payload => ({
    type: LOGIN_FAILURE,
    payload
})

export const logOutReq = payload => ({
    type: LOGOUT_REQUEST,
    payload
})

export const logOutSuccess = payload => ({
    type: LOGOUT_SUCCESS,
    payload
})

export const logOutFailure = payload => ({
    type: LOGOUT_FAILURE,
    payload
})

export const registerReq = payload => ({
    type: REGISTER_REQUEST,
    payload
})

export const registerSuccess = payload => ({
    type: REGISTER_SUCCESS,
    payload
})

export const registerFailure = payload => ({
    type: REGISTER_FAILURE,
    payload
})

export const resetPassword = payload => ({
    type: RESET_PASSWORD_REQUEST,
    payload
})

export const resetPasswordSuccess = payload => ({
    type: RESET_PASSWORD_SUCCESS,
    payload
})

export const resetPasswordFailure = payload => ({
    type: RESET_PASSWORD_FAILURE,
    payload
})

export const sendVerificationCodeReq = payload => ({
    type: SEND_VERIFICATION_CODE_REQUEST,
    payload
})

export const sendVerificationCodeSuccess = payload => ({
    type: SEND_VERIFICATION_CODE_SUCCESS,
    payload
})

export const sendVerificationCodeFailure = payload => ({
    type: SEND_VERIFICATION_CODE_FAILURE,
    payload
})

export const verifyPhoneNumberReq = payload => ({
    type: VERIFY_PHONE_NUMBER_REQUEST,
    payload
})

export const verifyPhoneNumberSuccess = payload => ({
    type: VERIFY_PHONE_NUMBER_SUCCESS,
    payload
})

export const verifyPhoneNumberFailure = payload => ({
    type: VERIFY_PHONE_NUMBER_FAILURE,
    payload
})

export const getMemberInfoReq = payload => ({
    type: GET_MEMBER_INFO_REQUEST,
    payload
})

export const getMemberInfoSuccess = payload => ({
    type: GET_MEMBER_INFO_SUCCESS,
    payload
})

export const getMemberInfoFailure = payload => ({
    type: GET_MEMBER_INFO_FAILURE,
    payload
})

export const updateMemberInfoReq = payload => ({
    type: UPDATE_MEMBER_INFO_REQUEST,
    payload
})

export const updateMemberInfoSuccess = payload => ({
    type: UPDATE_MEMBER_INFO_SUCCESS,
    payload
})

export const updateMemberInfoFailure = payload => ({
    type: UPDATE_MEMBER_INFO_FAILURE,
    payload
})

export const updateCreditCardReq = payload => ({
    type: UPDATE_CREDIT_CARD_REQUEST,
    payload
})

export const updateCreditCardSuccess = payload => ({
    type: UPDATE_CREDIT_CARD_SUCCESS,
    payload
})

export const updateCreditCardFailure = payload => ({
    type: UPDATE_CREDIT_CARD_FAILURE,
    payload
})

export const cleanMemberStatus = () => ({
    type: CLEAN_STATUS
})